import { render } from "./ModalHeader.vue?vue&type=template&id=1b24dc75"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__